import React, { useState, useEffect } from "react";
import FormInput from "Common/Custom/FormInput";
import FormSelect from "Common/Custom/FormSelect";
import FormDatePicker from "Common/Custom/ReactFlatpickr";
import FormInputFile from "Common/Custom/FormInputFile";
import FormPhoneInput from "Common/Custom/FormPhoneInput";
import FormInputPassword from "Common/Custom/FormInputPassword";
import FormTextarea from "Common/Custom/FormTextarea";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import { validateField } from "utils/validation";
import PropTypes from "prop-types";
import { getSelectOptions } from "utils/optionHelper";
import FormNumberInput from "Common/Custom/FormNumberInput";
import "../../EmployeeForm.css";

const AddEmployeeForm = ({
    fields = {},
    values = {},
    handleChange = () => { },
    handleFileChange = () => { },
    handleArrayChange = () => { },
    setValues = () => { },
    handleSubmit = () => { },
    loading = false,
    title = "Add Employee",
    errors = {},
    setErrors = () => { },
    rules = {},
    imagePreview = "",
    DivisionOptions = [],
    PositionOptions = [],
    SupervisorOptions = [],
}) => {
    const [activeTab, setActiveTab] = useState("basic");
    const [showTerminationInfo, setShowTerminationInfo] = useState(false);

    const enableLoginOptions = [
        { label: "Yes", value: "true" },
        { label: "No", value: "false" },
    ];

    const dutyTypeOptions = [
        { label: "Full-time", value: "FULL_TIME" },
        { label: "Part-time", value: "PART_TIME" },
        { label: "Contract", value: "CONTRACT" },
    ];

    const voluntaryTerminationOptions = [
        { label: "Yes", value: 1 },
        { label: "No", value: 0 },
    ];

    const rateTypeOptions = [
        { label: "Hourly", value: "HOURLY" },
        { label: "Salary", value: "SALARY" },
    ];

    const payFrequencyOptions = [
        { label: "Weekly", value: "WEEKLY" },
        { label: "Bi-Weekly", value: "BIWEEKLY" },
        { label: "Monthly", value: "MONTHLY" }
    ];

    const benefitStatusOptions = [
        { label: "Active", value: "ACTIVE" },
        { label: "Inactive", value: "INACTIVE" },
    ];

    const classStatusOptions = [
        { label: "Active", value: "ACTIVE" },
        { label: "Inactive", value: "INACTIVE" },
    ];

    const supervisorOptions = [
        { label: "Yes", value: "true" },
        { label: "No", value: "false" },
    ];

    const genderOptions = [
        { label: "Male", value: "MALE" },
        { label: "Female", value: "FEMALE" },
        { label: "Other", value: "OTHER" },
    ];

    const maritalStatusOptions = [
        { label: "Single", value: "single" },
        { label: "Married", value: "married" },
        { label: "Divorced", value: "divorced" },
    ];

    const workInStateOptions = [
        { label: "Yes", value: "true" },
        { label: "No", value: "false" },
    ];

    const citizenshipOptions = [
        { label: "Citizen", value: "citizen" },
        { label: "Non-Citizen", value: "non-citizen" },
    ];

    const tabs = [
        { id: 1, key: "basic", label: "Basic Info", icon: "bi-person-bounding-box" },
        { id: 2, key: "position", label: "Position Info", icon: "bi-briefcase" },
        { id: 3, key: "benefits", label: "Benefits", icon: "bi-gift" },
        { id: 4, key: "class", label: "Class", icon: "bi-diagram-3" },
        { id: 5, key: "supervisor", label: "Supervisor", icon: "bi-people" },
        { id: 6, key: "biographical", label: "Biographical", icon: "bi-person-lines-fill" },
        { id: 7, key: "contacts", label: "Additional Info", icon: "bi-telephone" },
        { id: 8, key: "emergency", label: "Emergency Contact", icon: "bi-life-preserver" },
        { id: 9, key: "custom", label: "Custom Fields", icon: "bi-gear" }
    ];

    const field_typeOptions = [
        { label: "Text", value: "TEXT" },
        { label: "Number", value: "NUMBER" },
        { label: "Date", value: "DATE" },
        { label: "Dropdown", value: "DROPDOWN" }
    ];

    const optionConfig = {
        division_id: {
            list: DivisionOptions,
            valueKey: "division_id",
            labelKey: "division_name",
        },
        position_id: {
            list: PositionOptions,
            valueKey: "position_id",
            labelKey: "position_name",
        },
        duty_type: {
            list: dutyTypeOptions,
            valueKey: "value",
            labelKey: "label",
        },
        enable_login: {
            list: enableLoginOptions,
            valueKey: "value",
            labelKey: "label",
        },
        voluntary_termination: {
            list: voluntaryTerminationOptions,
            valueKey: "value",
            labelKey: "label",
        },
        rate_type: {
            list: rateTypeOptions,
            valueKey: "value",
            labelKey: "label",
        },
        pay_frequency: {
            list: payFrequencyOptions,
            valueKey: "value",
            labelKey: "label",
        },
        benefit_status: {
            list: benefitStatusOptions,
            valueKey: "value",
            labelKey: "label",
        },
        class_status: {
            list: classStatusOptions,
            valueKey: "value",
            labelKey: "label",
        },
        is_supervisor: {
            list: supervisorOptions,
            valueKey: "value",
            labelKey: "label",
        },
        supervisor_employee_id: {
            list: SupervisorOptions,
            valueKey: "employee_id",
            labelKey: "full_name",
        },
        gender: {
            list: genderOptions,
            valueKey: "value",
            labelKey: "label",
        },
        marital_status: {
            list: maritalStatusOptions,
            valueKey: "value",
            labelKey: "label",
        },
        work_in_state: {
            list: workInStateOptions,
            valueKey: "value",
            labelKey: "label",
        },
        live_in_state: {
            list: workInStateOptions,
            valueKey: "value",
            labelKey: "label",
        },
        citizenship: {
            list: citizenshipOptions,
            valueKey: "value",
            labelKey: "label",
        },
        field_type: {
            list: field_typeOptions,
            valueKey: "value",
            labelKey: "label",
        },
    };

    useEffect(() => {
        if (values.is_supervisor === "true" && values.supervisor_employee_id) {
            handleChange({
                target: {
                    name: "supervisor_employee_id",
                    value: ""
                }
            });
        }
    }, [values.is_supervisor, values.supervisor_employee_id, handleChange]);


    const handleTabChange = (targetTabKey) => {
        const tabList = tabs.map(t => t.key);
        const currentIndex = tabList.indexOf(activeTab);
        const targetIndex = tabList.indexOf(targetTabKey);

        if (targetIndex <= currentIndex) {
            setActiveTab(targetTabKey);
            return;
        }

        const currentFields = fields[activeTab] || [];
        const currentErrors = {};

        if (activeTab === "custom") {
            const customRules = rules?.custom_fields || {};
            let hasError = false;
            const customErrors = (values.custom_fields || []).map((row) => {
                const rowErrors = {};
                Object.keys(customRules).forEach((field) => {
                    const error = validateField(field, row[field], customRules);
                    if (error) { rowErrors[field] = error; hasError = true; }
                });
                return rowErrors;
            });

            if (hasError) {
                setErrors((prev) => ({ ...prev, custom_fields: customErrors }));
                return;
            }
        } else {
            currentFields.forEach((field) => {
                const error = validateField(field.name, values[field.name], rules);
                if (error) currentErrors[field.name] = error;
            });

            if (Object.keys(currentErrors).length) {
                setErrors((prev) => ({ ...prev, ...currentErrors }));
                return;
            }
        }

        setActiveTab(targetTabKey);
    };

    const renderField = (field, value, onChange, error) => {
        if (field.showIf && values[field.showIf.field] !== field.showIf.value) return null;

        let disabled = false;
        if (field.name === "supervisor_employee_id" && values.is_supervisor === "true") {
            disabled = true;
        } else if (field.name === "salary") {
            field.label = `Salary ${values?.pay_frequency?.charAt(0).toUpperCase() + values?.pay_frequency?.slice(1).toLowerCase()}`
        }

        const commonProps = {
            key: field.name,
            field,
            value,
            handleChange: onChange,
            error,
            disabled
        };

        switch (field.type) {
            case "file":
                return (
                    <FormInputFile
                        {...commonProps}
                        handleChange={handleFileChange}
                        imagePreview={imagePreview}
                    />
                );
            case "number":
                return <FormNumberInput {...commonProps} />;
            case "phone":
                return <FormPhoneInput {...commonProps} />;
            case "password":
                return <FormInputPassword {...commonProps} />;
            case "textarea":
                return <FormTextarea {...commonProps} />;
            case "date":
                return <FormDatePicker {...commonProps} />;
            case "select":
                return <FormSelect {...commonProps} options={getSelectOptions(field.name, optionConfig)} />;
            default:
                return <FormInput {...commonProps} />;
        }
    };

    const handleCustomFieldChange = (index, name, value) => {
        const updatedCustom = [...(values.custom_fields || [])];
        updatedCustom[index] = { ...updatedCustom[index], [name]: value };
        setValues({ ...values, custom_fields: updatedCustom });
    };

    const addCustomField = () => {
        setValues({
            ...values,
            custom_fields: [...(values.custom_fields || []), { field_name: "", field_type: "TEXT", field_value: "" }]
        });
    };

    const removeCustomField = (index) => {
        const updatedCustom = values.custom_fields.filter((_, i) => i !== index);
        setValues({ ...values, custom_fields: updatedCustom });
    };

    return (
        <PageBody onSubmit={handleSubmit} headerchildren={<HeadingOne>{title}</HeadingOne>}>
            <div className="employee-tabs-container">
                <ul className="nav nav-tabs employee-tabs">
                    {tabs.map((t) => {
                        const hasError = errors[t.key] || (t.key === 'custom' && errors.custom_fields?.length);
                        const sectionFields = fields[t.key] || [];
                        const hasSectionError = sectionFields.some(f => errors[f.name]);
                        const tabHasError = hasError || hasSectionError;

                        return (
                            <li className="nav-item" key={t.key}>
                                <button
                                    type="button"
                                    className={`nav-link ${activeTab === t.key ? "active" : ""}`}
                                    onClick={() => handleTabChange(t.key)}
                                >
                                    <i className={`${t.icon}`}></i>
                                    <span>{t.label}</span>
                                    {tabHasError && <span className="badge bg-danger error-badge ms-1">!</span>}
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </div>

            <div className="tab-content">
                <div className="form-section-content">
                    {activeTab === "custom" ? (
                        <div className="custom-fields-container">
                            <div className="section-header">
                                <i className="bi bi-gear-fill"></i>
                                <h5 className="mb-0">Custom Employee Fields</h5>
                            </div>
                            {(values.custom_fields || []).map((cf, index) => (
                                <div key={index} className="card p-3 mb-3 custom-field-card position-relative">
                                    <button type="button" className="btn btn-sm btn-outline-danger position-absolute top-0 end-0 m-2" onClick={() => removeCustomField(index)}>
                                        <i className="bi bi-trash"></i>
                                    </button>
                                    <div className="row g-3">
                                        {fields.custom.map(field => (
                                            renderField(field, cf[field.name], (e) => handleCustomFieldChange(index, field.name, e.target.value), errors?.custom_fields?.[index]?.[field.name])
                                        ))}
                                    </div>
                                </div>
                            ))}
                            <button type="button" className="btn btn-outline-primary d-flex align-items-center gap-2" onClick={addCustomField}>
                                <i className="bi bi-plus-circle"></i> Add Custom Field
                            </button>
                        </div>
                    ) : activeTab === "position" ? (
                        <div className="position-info-container">
                            <div className="section-header">
                                <i className="bi bi-briefcase-fill"></i>
                                <h5 className="mb-0">Position & Employment Details</h5>
                            </div>
                            <div className="row g-3 mb-4">
                                {fields.position.filter(f => f.group === "Position_Details").map((field) => (
                                    renderField(field, values[field.name], handleChange, errors[field.name])
                                ))}
                            </div>

                            <div className="section-header">
                                <i className="bi bi-cash-stack"></i>
                                <h5 className="mb-0">Payroll Information</h5>
                            </div>
                            <div className="row g-3 mb-4">
                                {fields.position.filter(f => f.group === "Payroll_Info").map((field) => (
                                    renderField(field, values[field.name], handleChange, errors[field.name])
                                ))}
                            </div>

                            {fields.position.some(f => f.group === "Termination_Info") && (
                                <>
                                    <div className="section-header d-flex justify-content-between align-items-center">
                                        <div className="d-flex align-items-center gap-2">
                                            <i className="bi bi-person-x-fill text-danger"></i>
                                            <h5 className="mb-0 text-danger">Termination Info (Optional)</h5>
                                        </div>
                                        <button
                                            type="button"
                                            className={`btn btn-sm ${showTerminationInfo ? "btn-outline-secondary" : "btn-outline-danger"}`}
                                            onClick={() => setShowTerminationInfo(!showTerminationInfo)}
                                        >
                                            {showTerminationInfo ? "Hide" : "Show"} Termination Info
                                        </button>
                                    </div>
                                    {showTerminationInfo && (
                                        <div className="row g-3 mt-1">
                                            {fields.position.filter(f => f.group === "Termination_Info").map((field) => (
                                                renderField(field, values[field.name], handleChange, errors[field.name])
                                            ))}
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    ) : (
                        <div className="general-section-container">
                            <div className="section-header">
                                <i className={`${tabs.find(t => t.key === activeTab)?.icon} me-1`}></i>
                                <h5 className="mb-0">{tabs.find(t => t.key === activeTab)?.label}</h5>
                            </div>
                            <div className="row g-3">
                                {(fields[activeTab] || []).map((field) => (
                                    renderField(field, values[field.name], handleChange, errors[field.name])
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <div className="form-navigation d-flex justify-content-end gap-3 mt-4">
                <button
                    type="button"
                    className="btn btn-nav btn-prev"
                    onClick={() => {
                        const tabList = tabs.map(t => t.key);
                        const prevTab = tabList[tabList.indexOf(activeTab) - 1];
                        if (prevTab) handleTabChange(prevTab);
                    }}
                    disabled={activeTab === tabs[0].key}
                >
                    <i className="bi bi-arrow-left"></i> Previous
                </button>
                {activeTab !== tabs[tabs.length - 1].key ? (
                    <button type="button" className="btn btn-nav btn-next" onClick={() => {
                        const tabList = tabs.map(t => t.key);
                        const nextTab = tabList[tabList.indexOf(activeTab) + 1];
                        if (nextTab) handleTabChange(nextTab);
                    }}>
                        Next <i className="bi bi-arrow-right"></i>
                    </button>
                ) : (
                    <FormSubmitButton label="Save Employee" loading={loading} colSize="auto" />
                )}
            </div>
        </PageBody>
    );
};


AddEmployeeForm.propTypes = {
    fields: PropTypes.object,
    values: PropTypes.object,
    handleChange: PropTypes.func,
    handleFileChange: PropTypes.func,
    handleArrayChange: PropTypes.func,
    setValues: PropTypes.func,
    handleSubmit: PropTypes.func,
    loading: PropTypes.bool,
    title: PropTypes.string,
    errors: PropTypes.object,
    setErrors: PropTypes.func,
    rules: PropTypes.object,
    DivisionOptions: PropTypes.array,
    PositionOptions: PropTypes.array,
    SupervisorOptions: PropTypes.array,
    imagePreview: PropTypes.string,
};

export default AddEmployeeForm;
